import moment from 'moment';
import createStore from './store';
import featureFlagStore from './featureFlagStore';
import { Clip } from '@/domains/asset';
import {
  // TODO: uncomment this - https://www.notion.so/goldcast/Backlogs-2e9b42becca2807d9f1ed615b658d3cb?source=copy_link#2f5b42becca280c887ecff1c57297025
  // doesClipHavePlayerConfig,
  isClipAlignedStreamAvailable,
  isClipFromRecordingStudio,
  isClipLiveEvent,
  isClipLiveEventAndRemotionMigrationInProgress,
  isClipCompositeMp4Available
} from '@/libs/clipUtils';
import { isLiveEventWithAutoMigration } from '@/libs/mediaContentUtils';
import { infiniteSleep } from '@/libs/utils';
import { FeatureFlagKeys } from '@/services/featureFlag';

export enum ClipAvailabilityStatus {
  ALL_OK = 'ALL_OK',
  // TODO: uncomment this - https://www.notion.so/goldcast/Backlogs-2e9b42becca2807d9f1ed615b658d3cb?source=copy_link#2f5b42becca280c887ecff1c57297025
  // SHARED_PAGE_MISSING_PLAYER_CONFIG = 'SHARED_PAGE_MISSING_PLAYER_CONFIG',
  COMPOSITE_MP4_NOT_READY = 'COMPOSITE_MP4_NOT_READY',
  ALIGNED_STREAM_NOT_READY = 'ALIGNED_STREAM_NOT_READY',
  RECORDING_STUDIO_UNSUPPORTED_EVENT = 'RECORDING_STUDIO_UNSUPPORTED_EVENT',
  LIVE_EVENT_MIGRATION_IN_PROGRESS = 'LIVE_EVENT_MIGRATION_IN_PROGRESS'
}

export const clipAvailabilityStatus = createStore<Record<string, ClipAvailabilityStatus>>({});

const updateClipAvailabilityStatus = (clipId: string, status: ClipAvailabilityStatus) => {
  // eslint-disable-next-line no-console
  console.log(status);
  clipAvailabilityStatus.update(prevState => ({ ...prevState, [clipId]: status }));
};

export const waitForClipToBeReady = async ({ clip, isSharedPage }: { clip: Clip; isSharedPage: boolean }) => {
  // TODO: uncomment this when refactor SharedVideoTimedOut - https://www.notion.so/goldcast/Backlogs-2e9b42becca2807d9f1ed615b658d3cb?source=copy_link#2f5b42becca280c887ecff1c57297025
  // if (isSharedPage && !doesClipHavePlayerConfig(clip)) {
  //   updateClipAvailabilityStatus(clip.id, ClipAvailabilityStatus.SHARED_PAGE_MISSING_PLAYER_CONFIG);
  //   await infiniteSleep();
  // }

  const isCompositeMp4Applicable = !isClipFromRecordingStudio(clip);
  if (isCompositeMp4Applicable && !isClipCompositeMp4Available(clip) && !isSharedPage) {
    updateClipAvailabilityStatus(clip.id, ClipAvailabilityStatus.COMPOSITE_MP4_NOT_READY);
    await infiniteSleep();
  }

  if (isClipLiveEvent(clip) && isLiveEventWithAutoMigration(clip.content) && !isClipAlignedStreamAvailable(clip)) {
    // New live event
    updateClipAvailabilityStatus(clip.id, ClipAvailabilityStatus.ALIGNED_STREAM_NOT_READY);
    await infiniteSleep();
  }

  if (isClipLiveEventAndRemotionMigrationInProgress(clip)) {
    // Old live event
    updateClipAvailabilityStatus(clip.id, ClipAvailabilityStatus.LIVE_EVENT_MIGRATION_IN_PROGRESS);
    await infiniteSleep();
  }

  if (isClipFromRecordingStudio(clip) && !isClipAlignedStreamAvailable(clip)) {
    updateClipAvailabilityStatus(clip.id, ClipAvailabilityStatus.ALIGNED_STREAM_NOT_READY);
    await infiniteSleep();
  }

  if (isClipFromRecordingStudio(clip)) {
    const rsTestDate = Number(featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Test_RS_Date]);
    const createdAfterTestDate = rsTestDate && moment(clip.content.live_end_time).isAfter(moment(rsTestDate));
    if (!createdAfterTestDate) {
      updateClipAvailabilityStatus(clip.id, ClipAvailabilityStatus.RECORDING_STUDIO_UNSUPPORTED_EVENT);
      await infiniteSleep();
    }
  }

  updateClipAvailabilityStatus(clip.id, ClipAvailabilityStatus.ALL_OK);
};
